import { createContext } from 'react';
import { IFellowshipService } from "../../services/FellowshipService";

const ServerDBContext = createContext<IFellowshipService | null>(null);

export default ServerDBContext;